import { useEffect } from "react";
import "./../../styles/NaoEncontrada.css";
import { useSessionExpirationCheck } from "../../hooks/useSessionExpirationCheck";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const NaoEncontrada = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  const sessionExpiration = useSelector(
    (state: RootState) => state.auth.SessionExpiration
  );

  useSessionExpirationCheck(sessionExpiration, token);

  useEffect(() => {
    document.title = "Íkone | Página Não Encontrada";
  }, []);

  return (
    <div className="notfound-container">
      <div className="notfound-card">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-subtitle">Página não encontrada</p>
        <p className="notfound-description">
          A página que você está procurando não existe ou foi movida.
        </p>
        <a className="notfound-button" href="/">
          Voltar para a Home
        </a>
      </div>
    </div>
  );
};

export default NaoEncontrada;
